/**
 * OS ENDEREÇOS ANTIGOS DO PLAYBOOK (CERES-028).
 *
 * O módulo deixou de existir. Os links que as pessoas salvaram, não — e um
 * favorito que abre "página não encontrada" é indistinguível, para quem clica,
 * de um sistema que perdeu o conteúdo.
 *
 * Estes componentes vivem em `components/`, e não em `pages/`, de propósito:
 * não são telas. Não desenham nada, não têm texto e não aparecem para ninguém —
 * existem por uma fração de segundo entre a URL antiga e a nova.
 */

import { Navigate, useParams } from 'react-router-dom';

/**
 * `/playbook/secao/:kind` → a área que hoje guarda aquele tipo de conteúdo.
 *
 * A separação é a mesma que a missão estabeleceu: o que é transversal à casa
 * (processo, qualificação, treinamento, jurídico) ficou no Método Comercial; o
 * que é específico de produto passou a viver dentro da oferta, e por isso o
 * destino é a lista de Ofertas — de onde se escolhe QUAL oferta.
 */
const AREA_DA_SECAO: Record<string, string> = {
  processo: '/catalogo-comercial/metodo',
  qualificacao: '/catalogo-comercial/metodo',
  treinamento: '/catalogo-comercial/metodo',
  juridico: '/catalogo-comercial/metodo',
  perguntas: '/catalogo-comercial',
  objecoes: '/catalogo-comercial',
  faq: '/catalogo-comercial',
  cases: '/catalogo-comercial',
  templates: '/catalogo-comercial',
};

/**
 * A área do Catálogo que responde por uma seção do antigo Playbook.
 *
 * CERES-UX-001: os links internos passaram a apontar DIRETO para cá, em vez de
 * passar pelo endereço antigo e depender do redirecionamento.
 */
export function areaDaSecaoDoCatalogo(kind: string | undefined): string {
  // Seção desconhecida cai no Catálogo, e não em erro: o endereço existia, e a
  // central é o lugar de onde tudo o que ele mostrava passou a ser alcançável.
  return AREA_DA_SECAO[kind ?? ''] ?? '/catalogo-comercial';
}

export function RedirecionarSecaoDoPlaybook(): JSX.Element {
  const { kind } = useParams();
  return <Navigate to={areaDaSecaoDoCatalogo(kind)} replace />;
}

/** `/playbook/produto/:ofertaId` → a ficha daquela oferta, na aba padrão. */
export function RedirecionarFichaDaOferta(): JSX.Element {
  const { ofertaId } = useParams();
  return (
    <Navigate
      to={ofertaId === undefined ? '/catalogo-comercial' : `/catalogo-comercial/${ofertaId}`}
      replace
    />
  );
}
